exports.reactLocalStorage = {
  set: function set(key, value) {
    localStorage[key] = value;
    return localStorage[key];
  },
  get: function get(key) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var value = localStorage[key] || defaultValue; // if silent=false throw error

    if (!silent && !value) throw key + " not found in localStorage";
    return value;
  },
  setObject: function setObject(key, value) {
    localStorage[key] = JSON.stringify(value);
    return localStorage[key];
  },
  getObject: function getObject(key) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    value = this.get(key, JSON.stringify(defaultValue), silent);

    try {
      return JSON.parse(value);
    } catch (e) {
      // will raise error for parsing
      if (!silent) throw 'Error in parsing value';
    }
  },
  clear: function clear() {
    return localStorage.clear();
  },
  remove: function remove(key) {
    return localStorage.removeItem(key);
  }
};